import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import { get } from "lodash";
const ActiveField = ({ record, source }) => {
  const isActive = get(record, source, false);
  return <span>{isActive && <CheckIcon />}</span>;
};

export default ActiveField;
